// src/lib/layouts/subtitleVerticalTransform.ts
import type { SubtitleAlignItems } from './enforcedSubtitlePosition';

/**
 * Vertical offset (as % of frame height) the renderer applies to the subtitle
 * line on top of its flex anchor. Mirrors transformVerticalMarginAlignment in
 * src/components/remotion/Subtitle.tsx:
 * - top (flex-start): pushed down by the margin
 * - center: offset around the middle (50 = exactly centered)
 * - bottom (flex-end): pushed up by the margin
 */
export function subtitleVerticalTransformPercent(
  alignItems: SubtitleAlignItems,
  marginPercent: number,
): number {
  if (alignItems === 'center') return marginPercent - 50;
  if (alignItems === 'flex-end') return -marginPercent || 0; // avoid -0
  return marginPercent;
}
